import { motion } from "framer-motion";

export function HoardexaLoader({ fullscreen = false, label = "Loading Hoardexa", compact = false }) {
  const shellClass = fullscreen
    ? "fixed inset-0 z-[9999] flex items-center justify-center bg-[#fffafa]/70 backdrop-blur-md"
    : compact
      ? "mb-4 flex items-center justify-start"
      : "flex min-h-[calc(100dvh-160px)] items-center justify-center";
  const loaderSize = compact ? "h-12 w-12" : "h-16 w-16";
  const cardClass = compact
    ? "inline-flex items-center gap-3 rounded-full border border-[#eadfdf] bg-[#fffafa]/90 px-3 py-2 shadow-sm shadow-slate-950/5"
    : "relative flex min-w-[260px] items-center gap-4 overflow-hidden rounded-[28px] border border-[#eadfdf] bg-[#fffafa]/88 px-5 py-4 shadow-2xl shadow-slate-950/10 backdrop-blur-xl";

  return (
    <div className={shellClass} role="status" aria-live="polite">
      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -8, scale: 0.96 }}
        transition={{ duration: 0.26, ease: "easeOut" }}
        className={cardClass}
      >
        {!compact && (
          <>
            <motion.div
              className="absolute -left-10 -top-12 h-28 w-28 rounded-full bg-[#f4eeee] blur-2xl"
              animate={{ opacity: [0.45, 0.75, 0.45], scale: [0.9, 1.08, 0.9] }}
              transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="absolute -bottom-14 right-2 h-28 w-28 rounded-full bg-red-100/70 blur-3xl"
              animate={{ opacity: [0.35, 0.65, 0.35], scale: [1, 0.9, 1] }}
              transition={{ duration: 3.8, repeat: Infinity, ease: "easeInOut" }}
            />
          </>
        )}

        <div className={`relative flex flex-shrink-0 items-center justify-center ${loaderSize}`}>
          <motion.div
            className="absolute inset-0 rounded-full border border-[#e8dcdb]"
            animate={{ rotate: 360 }}
            transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
          >
            <span className="absolute left-1/2 top-0 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-black" />
          </motion.div>
          <motion.div
            className="absolute inset-1.5 rounded-full border border-blue-200"
            animate={{ rotate: -360 }}
            transition={{ duration: 4.5, repeat: Infinity, ease: "linear" }}
          >
            <span className="absolute bottom-0 left-1/2 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-blue-600" />
          </motion.div>
          <motion.div
            className="absolute inset-3 rounded-full bg-black shadow-lg shadow-slate-950/20"
            animate={{ scale: [0.92, 1, 0.92] }}
            transition={{ duration: 1.55, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute inset-[18px] rounded-full bg-[#fffafa]"
            animate={{ opacity: [0.82, 1, 0.82] }}
            transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
          />
          <div className={`relative font-display font-black text-black ${compact ? "text-xs" : "text-sm"}`}>
            H
          </div>
        </div>

        <div className="relative min-w-0 flex-1">
          <div className={`font-display font-bold text-black ${compact ? "text-sm" : "text-[15px]"}`}>Hoardexa</div>
          <div className={`${compact ? "max-w-[180px]" : "max-w-[220px]"} truncate text-xs font-semibold text-black/70`}>
            {label}
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-[#f0e6e6]">
            <motion.div
              className="h-full rounded-full bg-black"
              animate={{ x: ["-45%", "135%"] }}
              transition={{ duration: 1.15, repeat: Infinity, ease: "easeInOut" }}
              style={{ width: "45%" }}
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
}
